module.exports = {};



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_iterators.js
// module id = 46
// module chunks = 1